import { render, staticRenderFns } from "./ConfiguracaoEmailAutomaticoPage.vue?vue&type=template&id=633b4546"
import script from "./ConfiguracaoEmailAutomaticoPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoEmailAutomaticoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports